<ng-container style="position:relative">
	<div class="bars">
		<div class="bar" *ngFor="let bar of bars" [ngClass]="{'on':(bar==1),'blnk':(bar==2)}"></div>
	</div>
	<div *ngIf="scaleType=='pressure'" class="pressurebars">
		<div class="left-arrow">&nbsp;</div>
		<div class="right-arrow">&nbsp;</div>
	</div>
	<div *ngIf="scaleType=='timeline'||scaleType=='pressure'" class="timescale">
		<div class="lines">
			<div class="line" *ngFor="let bar of bars"></div>
		</div>
		<div *ngIf="scaleType=='timeline'" class="ticks">
			<div class="tick" *ngFor="let hour of [0,3,6,9,12,15,18,21,24]">{{hour}}</div>
		</div>
	</div>
</ng-container>
